import { render, staticRenderFns } from "./Verka-GoToTopButton.vue?vue&type=template&id=5637e171&"
import script from "./Verka-GoToTopButton.vue?vue&type=script&lang=ts&"
export * from "./Verka-GoToTopButton.vue?vue&type=script&lang=ts&"
import style0 from "./Verka-GoToTopButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFabTransition,VIcon})
